<template>
  <div class="dashboard-card">
    <div class="card-header"><awesomeIcon icon="coins" /> Valuta</div>
    <div class="card-graph">
      <GChart
        :settings="{ packages: ['corechart'], language: 'nl-nl' }"
        :data="data"
        :options="options"
        :events="chartEvents"
        @ready="setupChart"
        type="PieChart"
      />
    </div>
    <div class="card-bottom">
      <a class="button secondary" @click="legend=!legend" style="float: left;">
        <awesomeIcon icon="list-ul"/> Legenda
      </a>
      <a class="button secondary" @click="$parent.clickDetails('currency')">
        Meer info <awesomeIcon icon="angle-right"/>
      </a>
    </div>

    <div class="tooltip" id="currency-tooltip" />
    <div v-if="legend" class="legend-content">
      <div
        class="legend-bg" @click="legend=!legend"
        style="background-color:transparent; z-index:-1; pointer-events:none;"
      ></div>
      <table>
        <tr>
          <td
            colspan="3" @click="legend=!legend" class="legend-cancel"
            style="background-color: white"
          >Annuleren</td>
        </tr>
        <tr
          v-for="(item, index) in rows" :key="item.id"
          @mouseover="setSelection({ row: index, column: null })"
        >
          <td :style="bg(index)">&nbsp;</td>
          <td>{{item[0]}}</td>
          <td>&euro; {{formatPrice(item[1], true)}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { sumBy } from 'lodash-es';

export default {
  name: 'CurrencyWidget',
  data() {
    return {
      legend: false,
      options: {
        height: 250,
        pieHole: 0.7,
        pieSliceText: 'none',
        colors: this.$store.state.colorScheme,
        legend: {
          position: 'none',
        },
        tooltip: {
          trigger: 'none',
        },
        chartArea: {
          left: 10,
          top: 10,
          bottom: 10,
          right: 10,
          width: '100%',
          height: '100%',
        },
      },
      columns: [
        {
          type: 'string',
          label: 'Valuta',
        },
        {
          type: 'number',
          label: 'Waarde',
        },
      ],
      chartEvents: {
        onmouseover: this.setSelection,
        ready: () => {
          this.setSelection({ row: 0, column: null });
        },
      },
      chart: null,
    };
  },
  computed: {
    rows() {
      return this.$parent.getRows('currency', true);
    },
    data() {
      return [this.columns].concat(this.$parent.getRows('currency', true));
    },
  },
  methods: {
    setupChart(chartObject) {
      this.chart = chartObject;
    },
    setSelection(object) {
      if (object !== null) {
        this.chart.setSelection([object]);
        this.setTooltipContent(object.row);
      }
    },
    bg(index) {
      return `background-color: ${this.options.colors[index % this.options.colors.length]}`;
    },
    setTooltipContent(row) {
      if (row !== null) {
        const tooltip = document.getElementById('currency-tooltip');
        tooltip.innerHTML = `<b>${this.rows[row][0]}</b><br>&euro; ${this.formatPrice(this.rows[row][1], true)}<br>${this.formatPrice((this.rows[row][1] * 100) / sumBy(this.rows, 1), true)}%`;
      }
    },
  },
};
</script>
